<mat-dialog-content>
    <div class="w-full mb-5">
        <h3 class="text-center">Please add week activity from library</h3>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="bg-gray text-contrast-black" mat-dialog-close tabindex="-1">Ok</button>
</mat-dialog-actions>
